import { Flex } from 'common/src/designSystem/components/flex';
import * as React from 'react';
import { OmnibarTitle } from './omnibarTitle';

interface IOmnibarSectionProps {
    children: React.ReactNode[];
    title: string;
}

export const OmnibarSection = (props: IOmnibarSectionProps) => (
    <Flex direction="column">
        <OmnibarTitle>{props.title}</OmnibarTitle>

        {props.children}
    </Flex>
);
